export enum PrinterStatusMessage {
  Unknown = 'DESCONOCIDO',
  Connecting = 'CONECTANDO',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Printing = 'IMPRIMIENDO',
  Disabled = 'DESHABILITADA',
  TicketHoldInMouth = 'TICKET EN BOQUILLA',
  Error = 'ERROR',
  LoadingPrinting = 'PREPARANDO IMPRESIÓN',
  PaperJam = 'ATASCO PAPEL',
  CoverOpened = 'PUERTA ABIERTA',
  NoPaper = 'FALTA PAPEL',
  ErrorHeadUp = 'error HEAD UP',
  ErrorHeadTemp = 'error TEMP CABEZAL',
  ErrorCOM = 'error COM',
  ErrorNoTack = 'error NOTACK',
  ErrorCutter = 'error CUTTER',
  CutterCoverOpened = 'cuttercoveropen',
  ErrorRAM = 'error RAM',
  ErrorEPROM = 'error EPROM',
  LFKey = 'lf KEY',
  FFKey = 'ff KEY',
  NotchFound = 'NOTCH FOUND',
  NearPaperEnd = 'POCO PAPEL',
}
